import Skill from './model';

export default Skill;



// WEBPACK FOOTER //
// ./data/ProgressTests/Skills/index.js